module.exports = __webpack_public_path__ + "aa6639dc.webp";